exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".message-module-root{display:flex;font-size:13px;padding-left:8px}.message-module-root p{margin:0 9px}.message-module-root:empty{display:none}.message-module-root_error{color:#992631}", ""]);

// Exports
exports.locals = {
	"root": "message-module-root",
	"root_error": "message-module-root_error message-module-root"
};